import { useEffect } from 'react'

export type HubSelectOption = { label: string; value: string }

export function buildMarketSelectOptions(
  rows: { workerMarket: string }[]
): HubSelectOption[] {
  return Array.from(
    new Set(rows.map((row) => row.workerMarket).filter(Boolean))
  )
    .sort((marketA, marketB) => marketA.localeCompare(marketB))
    .map((market) => ({ label: market, value: market }))
}

export function buildStateSelectOptions(
  rows: { workerW2States: string[] }[]
): HubSelectOption[] {
  return Array.from(new Set(rows.flatMap((row) => row.workerW2States)))
    .sort((stateA, stateB) => stateA.localeCompare(stateB))
    .map((state) => ({ label: state, value: state }))
}

export function useClearStaleQueryParam(
  param: string | null,
  validValues: string[],
  clear: () => void
) {
  useEffect(() => {
    if (param != null && !validValues.includes(param)) {
      clear()
    }
  }, [param, validValues, clear])
}
